const bundle = {
  close: () => 'Zavřít',
  error: () => 'Chyba',
  warn: () => 'Varování',
  info: () => 'Informace',
  confirmation: () => 'Potvrzení',
  progressIndeterminate: () => 'Probíhá',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Mezi ' + p['FROM_SECTION'] + ' a ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nebyl nalezen žádný odpovídající oddíl.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Stisknutím klávesy Enter vyberte hodnotu.',
  indexer_touchInstructionText: () =>
    'Dvojitým klepnutím a přidržením přejděte do režimu gest, poté tažením nahoru nebo dolů upravte hodnotu.',
  inputPassword_show: () => 'Zobrazit heslo',
  inputPassword_hide: () => 'Skrýt heslo',
  inputPassword_hidden: () => 'Heslo skryté',
  formControl_clear: () => 'Vymazat',
  formControl_loading: () => 'Načítání',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maximální délka ' + p['MAX_LENGTH'] + ' překročena.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' zbývajících znaků.',
  select_noMatchesFound: () => 'Nebyly nalezeny žádné shody.',
  select_oneMatchFound: () => 'Nalezena jedna odpovídající položka',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' - počet nalezených shod',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' nebo více shod nalezeno',
  selectMultiple_showSelectedValues: () => 'Zobrazit pouze vybrané hodnoty.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' -  vybrané hodnoty.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selector_selected: () => 'Zaškrtávací políčko zaškrtnuto',
  selector_unselected: () => 'Zaškrtávací políčko nezaškrtnuto',
  userAssistance_learnMore: () => 'Další informace',
  userAssistance_required: () => 'Požadováno',
  filePicker_singleFileUploadError: () => 'Odesílejte pouze po jednom souboru',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Nelze odesílat soubory typu ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Nelze odesílat soubory typu: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'neznámý',
  filePicker_dropzonePrimaryText: () => 'Přetáhnout',
  filePicker_dropzoneSecondaryText: () => 'Vyberte soubor, nebo jej přetáhněte sem',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Vyberte, nebo přetáhněte soubor sem',
  filePicker_addFiles: () => 'Přidat soubory',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Zvýšení',
  inputNumber_decrease: () => 'Snížení',
  inputNumber_converterParseError: () => 'Enter a number.',
  noData_message: () => 'Neexistují položky k zobrazení',
  message_navigationFromMessagesRegion: () =>
    'Vstupujete do oblasti zpráv. Stisknutím klávesy F6 můžete přecházet zpět k dříve zaměřenému prvku.',
  message_navigationToMessagesRegion: () =>
    'V oblasti zpráv se nacházejí nové zprávy. Stisknutím klávesy F6 přejděte k naposledy otevřené oblasti zpráv.',
  messageToast_allMessagesClosed: () => 'Všechny informační zprávy jsou zavřeny.'
};
export default bundle;
